export const getUnusedColorFromPalette = (colorPalette: string[], usedColorPalette: Set<string>): string => {
  const availableColors = colorPalette.filter((color) => !usedColorPalette.has(color));

  const colorToBeUsed = availableColors[0];

  usedColorPalette.add(colorToBeUsed);

  if (usedColorPalette.size === colorPalette.length) {
    usedColorPalette.clear();
  }

  return colorToBeUsed;
};

export const removeUnusedColor = (color: string | undefined, usedColorPalette: Set<string>): Set<string> => {
  if (color && usedColorPalette.has(color)) {
    usedColorPalette.delete(color);
  }

  return usedColorPalette;
};
